// extracted by mini-css-extract-plugin
export var centerList = "_f1-6";
export var centerLoc = "_f1-a";
export var centerName = "_f1-9";
export var centerOptionBody = "_f1-8";
export var centerRow = "_f1-7";
export var centerStatus = "_f1-b";
export var empty = "_f1-5";
export var externalIcon = "_f1-c";
export var fieldHeader = "_f1-2";
export var fieldHelp = "_f1-4";
export var fieldLabel = "_f1-3";
export var panel = "_f1-0";
export var removeBtn = "_f1-d";
export var section = "_f1-1";